import React from 'react';
import './PostgreSQLModalStyle.css'; // Dodaj ako već nije

export const PostgreSQLModalContent = ({ setHost, setPort, setDatabase, setUser, setPassword }) => {
    return (
      <div className="pg-modal-content">
        <div className="pg-form-group">
          <label>Host:</label>
          <input type="text" onChange={(e) => setHost(e.target.value)} />
        </div>
        <div className="pg-form-group">
          <label>Port:</label>
          <input type="text" onChange={(e) => setPort(e.target.value)} />
        </div>
        <div className="pg-form-group">
          <label>Database:</label>
          <input type="text" onChange={(e) => setDatabase(e.target.value)} />
        </div>
        <div className="pg-form-group">
          <label>User:</label>
          <input type="text" onChange={(e) => setUser(e.target.value)} />
        </div>
        <div className="pg-form-group">
          <label>Password:</label>
          <input type="password" onChange={(e) => setPassword(e.target.value)} />
        </div>
      </div>
    );
  };